export default {
  sm: `
  Even at this very
  moment, millions of
  people around the
  world are creating
  and using a massive
  amount of data.
  `,
  lg: `
  Even at this very moment,
  millions of people around the
  world are creating and using
  a massive amount of data.
  `
};
